import View from './view';
import Input from './input';
import {target} from '../utils/dom';


function hover(el, input) {
	el.classList.add('hover');
}

function out(el, input) {
	el.classList.remove('hover');
}

function focus(el, input) {
	el.classList.add('focus');
}

function blur(el, input) {
	el.classList.remove('focus');
}

function valid(el, input) {
	el.classList.remove('invalid');
}

function invalid(el, input) {
	el.classList.add('invalid');
}

function onFileChange(el, input) {
	let fileInput = el.query('input[type=file]');
	let textInput = el.query('input[type=text]');
	textInput.value = fileInput.value;
}

function onInputChange(el, input, value) {
	if (!value || value === '') {
		el.classList.remove('filled');
	} else {
		el.classList.add('filled');
	}
	if (input.getType() === 'select') {
		onSelectChange(el, input, value);
	}
}

function onSelectChange(el, input, value) {
	if (!value) {
		el.classList.add('empty');
	} else {
		el.classList.remove('empty');
	}
}

const inputSelector = '.slx-form__input';


class Form extends View {
	constructor(options) {
		super(options);
		this.inputs = [];
	}

	start() {
		super.start();
		this.initInputs(this.el);
	}

	initEvents() {
		this.el.addEventListener('cloneAdd', this.onClonerAdd.bind(this));
	}

	initInputs(container, empty = false) {
		for (const el of container.querySelectorAll(inputSelector)) {
			this.initInput(el, empty);
		}
	}

	initInput(el, empty = false) {
		const input = new Input({el: el.querySelector('input, textarea, select, file')});
		input.start();
		if (empty) {
			input.empty();
		}
		input.events.on('change', onInputChange.bind(this, el, input));
		input.events.on('hover', hover.bind(this, el, input));
		input.events.on('out', out.bind(this, el, input));
		input.events.on('focus', focus.bind(this, el, input));
		input.events.on('blur', blur.bind(this, el, input));
		input.events.on('valid', valid.bind(this, el, input));
		input.events.on('invalid', invalid.bind(this, el, input));
		input.events.on('fileChange', onFileChange.bind(this, el, input));
		this.inputs.push(input);

		onInputChange(el, input, input.getValue());
	}

	onClonerAdd(event) {
		const cloner = target(event.target, '.slx-cloner');
		const clone = event.detail.clone;
		this.initInputs(clone, true);
	}
}

const forms = document.querySelectorAll('.slx-form');
for (const elt of forms) {
	new Form({el: elt}).start();
}
